/* One locale-aware AJAX add for native Dawn and ELIX forms. Never retry a cart mutation. */
(() => {
  if (window.ElixCartAdd) return;
  const pending = new WeakMap();
  function selectedKit(form) {
    const input = form.querySelector('[data-research-kit]');
    if (!input?.checked) return null;
    if (input.disabled || input.closest('elix-research-kit')?.dataset.kitAvailable !== 'true' || !/^\d+$/.test(input.dataset.variantId || '')) {
      throw new Error(input.closest('elix-research-kit')?.dataset.unavailable || window.ElixCartAddStrings?.error);
    }
    return input.dataset.variantId;
  }
  function formData(form) {
    const original = new FormData(form);
    const kit = selectedKit(form);
    if (!kit) return original;
    const data = new FormData();
    for (const [key, value] of original) {
      if (key === 'id' || key === 'quantity' || key === 'selling_plan') data.append(`items[0][${key}]`, value);
      else if (key.startsWith('properties[')) data.append(`items[0][properties]${key.slice('properties'.length)}`, value);
      else if (!['form_type', 'utf8', 'product-id', 'section-id', 'add'].includes(key)) data.append(key, value);
    }
    if (!original.has('quantity')) data.append('items[0][quantity]', '1');
    data.append('items[1][id]', kit);
    data.append('items[1][quantity]', '1');
    return data;
  }
  function add(form, { cart } = {}) {
    if (pending.has(form)) return pending.get(form);
    const promise = (async () => {
      const body = formData(form);
      if (cart) {
        body.set('sections', cart.getSectionsToRender().map(section => section.id).join(','));
        body.set('sections_url', location.pathname + location.search);
        cart.setActiveElement(document.activeElement);
      }
      const response = await fetch(window.routes?.cart_add_url || `${window.Shopify?.routes?.root || '/'}cart/add.js`, {
        method: 'POST', headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' }, body,
      });
      const result = await response.json();
      if (!response.ok || result.status || result.errors) {
        const error = new Error(typeof result.description === 'string' ? result.description : window.ElixCartAddStrings?.error);
        error.cartResponse = result;
        throw error;
      }
      // Bundled add returns items[]; Dawn's notification expects the first added line key.
      if (result.items?.length) { result.key = result.items[0].key; result.id = result.items[0].id; }
      return result;
    })();
    pending.set(form, promise);
    return promise.finally(() => { if (pending.get(form) === promise) pending.delete(form); });
  }
  window.ElixCartAdd = { add, formData, selectedKit };
})();
